import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  const scrollToChecklist = () => {
    document.getElementById('checklist-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="px-6 py-16 md:py-24 max-w-4xl mx-auto text-center">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-4xl md:text-5xl font-extrabold text-brand-black mb-6 leading-tight">
          Checklist Antes de Publicar
        </h1>
        <p className="text-lg md:text-xl text-brand-gray mb-10 max-w-3xl mx-auto leading-relaxed font-medium">
          Para negocios de servicios del hogar que quieren que sus publicaciones expliquen mejor su trabajo, generen confianza local y ayuden a que más clientes los encuentren.
        </p>
        
        <div className="bg-brand-light p-6 rounded-2xl border border-gray-200 mb-10 text-left max-w-3xl mx-auto">
          <p className="text-brand-black text-lg">
            Antes de subir otra foto de "trabajo terminado", revisa si tu publicación le dice al cliente tres cosas importantes: <strong>qué hiciste, dónde trabajas y qué problema resolviste.</strong>
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button 
            onClick={scrollToChecklist}
            className="w-full sm:w-auto px-8 py-4 bg-brand-cyan text-brand-black font-bold rounded-xl hover:bg-opacity-90 transition-all shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
          >
            Empezar checklist
          </button>
          <a 
            href="https://digitaltrack.co/free-consultation"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto px-8 py-4 bg-brand-black text-white font-bold rounded-xl hover:bg-opacity-90 transition-all shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
          >
            Agendar consulta gratis
          </a>
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;